import TYPES from '../../types';

// Domain
import { StateEntity } from '../../domain/entities/state-entity';
import { StateRepository } from '../../domain/repository/state-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchStatesQuery extends Query<Promise<Array<StateEntity>>> {
  @Inject(TYPES.CATALOG_ALLIANZ_STATE_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_ALLIANZ_STATE_REPOSITORY)
  private readonly repository!: StateRepository;

  internalExecute(codpais: string): Promise<Array<StateEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.current_codpais !== codpais) {
        this.repository.execute(codpais)
          .then((items) => {
            this.state_manager.patch({ items, current_codpais: codpais });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
